/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Passwords_Do_Not_MatchInputs */

const en_common_passwords_do_not_match = /** @type {(inputs: Common_Passwords_Do_Not_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwords do not match`)
};

const es_common_passwords_do_not_match = /** @type {(inputs: Common_Passwords_Do_Not_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las contraseñas no coinciden`)
};

/**
* | output |
* | --- |
* | "Passwords do not match" |
*
* @param {Common_Passwords_Do_Not_MatchInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_passwords_do_not_match = /** @type {((inputs?: Common_Passwords_Do_Not_MatchInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Passwords_Do_Not_MatchInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_passwords_do_not_match(inputs)
	return en_common_passwords_do_not_match(inputs)
});